export default {
  data: [
    {
      id: 0,
      customValues: {},
      resourcesToTasks: {},
      tasks: [],
      links: [],
      is_archived: false,
      workloadData: {
        durationData: {},
        estimation_mode: 1,
        apply_resource_calendar: true,
      },
    },
  ],
};
